<template>
  <div class="comment-activity">
    <activity-header
      :theme-color="themeColor"
      :activity="activity"
      :team-id="teamId"
      :created-at="activity.createdAt"
      :show-team-org-name="showTeamOrgName"
      action-label="gave an award"
      @reacted="$emit('reacted')"
    />
    <div class="meta">
      <activity-entity :project="project" :goal="goal" v-if="showEntityInfo" :activity="activity" />
      <div class="d-flex" v-else>
        <initiative-icon
          :is-done-and-closed="activity.initiative.isDoneAndClosed"
          v-if="entityName === 'initiative'"
        />
        <i class="flex-shrink-0 mr-2 entity-icon" :class="entityMeta.icon" v-else></i>
        <div class="bold entity-title text-small-1" v-no-capture>
          {{ entityTitle }}
        </div>
      </div>
      <award-widget class="left-space" :award="activity.award" />
      <reactions-list
        class="mt-3 left-space"
        :event="activity"
        @reacted="$emit('reacted')"
        v-if="areReactionsAvailable"
      />
    </div>
  </div>
</template>

<script>
import ActivityEntity from '@/components/activity/ActivityEntity'
import InitiativeIcon from '@/components/initiative/InitiativeIcon'
import ReactionsList from '@/components/reactions/ReactionsList'
import { AWARD_TYPE } from '@/constants/awards'
import { ROUTE_NAMES } from '@/constants/routes'
import getAwardMeta from '@/utils/getAwardMeta'
import * as R from 'ramda'
import ActivityHeader from '@/components/activity/ActivityHeader'
import AwardWidget from '@/components/award/AwardWidget'

const entityMetaMap = {
  goal: {
    icon: 'goal-icon-greyed',
    routeName: ROUTE_NAMES.GOAL
  },
  keyResult: {
    icon: 'kr-icon-greyed',
    routeName: ROUTE_NAMES.KR
  },
  initiative: {
    routeName: ROUTE_NAMES.INITIATIVE
  }
}

/**
 * This component gives view for award activity
 */
export default {
  name: 'AwardActivity',
  components: {
    InitiativeIcon,
    ActivityHeader,
    AwardWidget,
    ReactionsList,
    ActivityEntity
  },
  props: ['activity', 'showEntityInfo', 'themeColor', 'showTeamOrgName', 'goal', 'project'],
  data() {
    return {
      awardMeta: getAwardMeta(this.activity.award)
    }
  },
  computed: {
    teamId() {
      return (this.project || this.goal)?.teamId
    },
    areReactionsAvailable() {
      return !R.isEmpty(this.activity.reactionSummary)
    },
    isCheckinAward() {
      return R.pathEq(['award', 'type'], AWARD_TYPE.CHECKIN, this.activity)
    },
    krSnapshot() {
      return R.path(['award', 'context', 'keyResultSnapshot'], this.activity)
    },
    entityName() {
      if (this.awardMeta.onKr) return 'keyResult'
      else if (this.awardMeta.onInitiative) return 'initiative'
      else return 'goal'
    },
    entityMeta() {
      return entityMetaMap[this.entityName]
    },
    entityTitle() {
      if (this.awardMeta.isGoalAward || this.awardMeta.isKrAward) {
        return R.path(['award', 'context', 'title'], this.activity)
      } else if (this.awardMeta.onInitiative) {
        return R.path(['initiative', 'title'], this.activity)
      } else {
        return R.path(['award', 'context', this.entityName, 'title'], this.activity)
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

.meta {
  margin-left: 38px;
}

.entity-icon {
  width: 11px;
  height: 11px;
  margin-top: 4px;
  background-size: contain;
}

.left-space {
  padding-left: 24px;
}
</style>
